const { LitElement, html, css, ref, repeat, createRef, unsafeHTML } = window.Lit;

customElements.define('template-selector', class TemplateSelector extends LitElement {

    static properties = {
        value:              { type: Object },
        templates:          { type: Array },
        selectedTemplate:   { type: Object, state: true },
        currentStep:      { type: Number, state: true },
    };

    constructor() {
        super();
        this.currentStep = 1;
    }


    createRenderRoot() { return this; }

    onSelectedTemplate(template) {
        this.selectedTemplate = template;
        console.log('selected template')
        this.currentStep = 2;
    }

    render() {
        if (this.currentStep === 1) {
            return this._renderStep1();
        } else {
            return this._renderStep2();
        }
    }

    _renderStep1() {
        return html`
            <div class="list-group mt-3 mb-3">
                ${repeat(this.templates, (template) => {
                    return html`
                        <a class="list-group-item list-group-item-action" @click=${() => this.onSelectedTemplate(template)}>
                            <label class="form-check-label" for="template_${template.id}">
                                <strong>${template.templateName}</strong>
                                <p class="mb-0 text-muted">${template.components[0].text}</p>
                            </label>
                        </a>
                    `
                })}
            </div>
            <pre class="pre">${JSON.stringify(this.templates, null, 2)}</pre>
        `;
    }

    _renderStep2() {
        return html`
            <div class="div">
                <p>Rellena los valores</p>

                <p>
                    ${this.selectedTemplate.components[0].text}
                </p>
                
                ${this.selectedTemplate.parameters.body.map((parameter, index) => html`
                    <div class="mb-3">
                        <label class="form-label">${parameter.name}</label>
                        <input type="text" class="form-control" placeholder="Enter value" value=${parameter.defaultValue}>
                    </div>
                `)}

                <pre class="pre">${JSON.stringify(this.selectedTemplate, null, 2)}</pre>
                
            </div>
        `;
    }
});
